import { createGlobalStyle } from 'styled-components';

import { type Theme } from '@/utils/theme/themes';

import { AnimationDeclarations } from './Animation';
import { HeadingDeclarations } from './Heading';
import { TextDeclarations } from './Text';

/**
 * Create typesafe classes derived from our theme.
 * Don't love this, but seems like the only typesafe
 * route.
 */
export const UtilityCss = createGlobalStyle<{ theme?: Theme }>`
    @layer utility {
      ${TextDeclarations}
      ${HeadingDeclarations}
      ${AnimationDeclarations}
    }
`;
